import { Injectable } from '@angular/core';
import { AuthRolService } from '../../../core/services/auth-rol.service';

@Injectable({
  providedIn: 'root',
})
export class QualityControlAuthService extends AuthRolService {
  protected totalPermits = ['Admin'];

  protected allAccessPlus(roles: string[]): string[] {
    return [...roles, ...this.totalPermits];
  }

  protected accessTo(roles: string[]): boolean {
    return this.lookForRolesNeeded(this.allAccessPlus(roles));
  }

  deleteInspection(): boolean {
    return this.accessTo(['QualityControl']);
  }

  registerData(): boolean {
    return this.accessTo(['QualityControl', 'QualityControlInspector']);
  }

  deleteSingleMeasurement(): boolean {
    return this.accessTo(['QualityControl']);
  }

  validateTests(): boolean {
    return this.accessTo(['QualityControl', 'QualityControlLaboratory']);
  }

  editInspectionSheet(): boolean {
    return this.accessTo(['QualityControl']);
  }

  addInspectionMeasureType(): boolean {
    return this.accessTo(['QualityControl']);
  }

  addSpecialLabelData(): boolean {
    return this.accessTo(['QualityControl']);
  }

  createRejection(): boolean {
    return this.accessTo(['QualityControl']);
  }

  minimalQuantityOf2(): boolean {
    return this.accessTo(['QualityControl']);
  }

  /**
   * Whether the current user can trigger a "print labels with quantity"
   * action from the QC view. Disabled by default — each department overrides
   * this in its own auth service if needed.
   */
  printLabelWithQuantity(): boolean {
    return false;
  }
}
